import axios, { type AxiosResponse } from "axios";
import { useAuthStore } from "@/store";
import { useStore } from "vuex";
import { ss } from "@/utils/storage";
const baseURL =
  process.env.VUE_APP_API_BASE || "https://api.panomobi.com/api";
const service = axios.create({
  baseURL,
  timeout: 2400 * 1000,
});
// const authStore = useAuthStore()
service.interceptors.request.use(
  (config) => {
    // const token = useAuthStore().token;
    const token = localStorage.getItem("token");
    // const uuid = useAuthStore().guestid;
    const uuid = ss.get("uuidToken");
    // console.log(uuid)
    if (token) {
      config.headers.token = `${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error.response);
  }
);

service.interceptors.response.use(
  (response: AxiosResponse): AxiosResponse => {
    if ([200, 201].includes(response.status)) return response;

    throw new Error(response.status.toString());
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default service;
